import { Component, OnInit } from '@angular/core';
import { BaseModalContainer
  , ModalContainerService
  , ModalService
  , UserService
  , ModelDataService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { Zanimanje } from './zanimanje';

@Component({
  selector: 'yt-zanimanje',
  templateUrl: './zanimanje.component.html'
})
export class ZanimanjeComponent
 extends BaseModalContainer<Zanimanje>
  implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Zanimanje>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService,
    protected modelDataService: ModelDataService
  ) {
    super(modalContainerService
      , activatedRoute
      , modalService
      , userService
      , modelDataService);
  }

  ngOnInit() {
  }

}
